export function CardIcon({ className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="31"
      viewBox="0 0 34 31"
      fill="none"
    >
      <g filter="url(#filter0_d_2907_2349)">
        <path
          className={className}
          d="M13.4104 8.78375H15.0783C16.3065 8.78375 17.3022 9.77942 17.3022 11.0076V12.6756C17.3022 13.9038 16.3065 14.8994 15.0783 14.8994H13.4104C12.1822 14.8995 11.1865 13.9038 11.1865 12.6756V11.0076C11.1865 9.77942 12.1822 8.78375 13.4104 8.78375Z"
          fillOpacity="0.8"
        />
        <path
          className={className}
          d="M20.6362 8.78381H22.3042C23.5324 8.78381 24.528 9.77948 24.528 11.0077V12.6756C24.528 13.9038 23.5324 14.8995 22.3042 14.8995H20.6362C19.408 14.8995 18.4124 13.9038 18.4124 12.6756V11.0077C18.4123 9.77948 19.408 8.78381 20.6362 8.78381Z"
          fillOpacity="0.8"
        />
        <path
          className={className}
          d="M13.4097 16.012H15.0776C16.3058 16.012 17.3015 17.0076 17.3015 18.2358V19.9038C17.3015 21.132 16.3058 22.1277 15.0776 22.1277H13.4097C12.1815 22.1277 11.1858 21.132 11.1858 19.9038V18.2359C11.1858 17.0076 12.1815 16.012 13.4097 16.012Z"
          fillOpacity="0.8"
        />
        <path
          className={className}
          d="M20.6362 16.012H22.3042C23.5324 16.012 24.528 17.0076 24.528 18.2358V19.9038C24.528 21.132 23.5324 22.1277 22.3042 22.1277H20.6362C19.408 22.1277 18.4124 21.132 18.4124 19.9038V18.2359C18.4123 17.0076 19.408 16.012 20.6362 16.012Z"
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2907_2349"
          x="-1.7569"
          y="-1.49078"
          width="37.8951"
          height="33.8922"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.13419" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.154167 0 0 0 0 0.154167 0 0 0 0 0.154167 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2907_2349"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2907_2349"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
